export const SKELETON = {
  width: 80,
  height: 14,
};

export const CLASSNAME = 'ml-4';
